/**
 * Browser environment detection utility.
 *
 * Essential for Next.js applications that need to differentiate between
 * server-side rendering (SSR) and client-side execution contexts.
 *
 * @module isBrowser
 */

/**
 * Determines if code is running in a browser environment.
 *
 * Uses the presence of the `window` object to detect browser context.
 * Critical for avoiding SSR hydration mismatches and preventing server-side
 * execution of browser-only APIs.
 *
 * @returns {boolean} True if running in browser, false if in Node.js/SSR context
 *
 * @example
 * ```typescript
 * // Safe DOM manipulation
 * if (isBrowser()) {
 *   window.location.href = 'https://example.com';
 * }
 *
 * // Conditional hook usage
 * const data = isBrowser() ? useClientHook() : null;
 * ```
 */
const isBrowser = (): boolean => {
  return typeof window !== "undefined";
};

export default isBrowser;
